<template>
  <b-col cols="12">
    <b-card>
      <template #header>
        <h4 class="mb-0">
          🕒 Últimas Campanhas
        </h4>
      </template>
      <div
        v-if="loading"
        class="text-center p-4"
      >
        <b-spinner />
        <p class="mt-2 mb-0">
          Carregando campanhas...
        </p>
      </div>
      <b-table
        v-else
        :items="ultimasCampanhas"
        :fields="camposTabela"
        responsive
        striped
        hover
        show-empty
        empty-text="Nenhuma campanha encontrada"
      >
        <template #cell(name)="data">
          <div>
            <strong>{{ data.item.name }}</strong>
          </div>
        </template>

        <template #cell(audiencia)="data">
          <div>
            <span class="text-primary font-weight-bold">{{ data.item.audiencia || 0 }}</span>
            <small class="text-muted d-block">contatos</small>
          </div>
        </template>

        <template #cell(conversao)="data">
          <div>
            <div class="d-flex align-items-center">
              <span class="text-success font-weight-bold mr-2">{{ data.item.taxa_conversao || 0 }}%</span>
              <small class="text-muted">+ R$ {{ formatarMoeda(data.item.valor_total || 0) }}</small>
            </div>
          </div>
        </template>

        <template #cell(status)="data">
          <b-badge
            :variant="getStatusVariantCampanha(data.item.status)"
            pill
          >
            {{ getStatusLabelCampanha(data.item.status) || '-' }}
          </b-badge>
        </template>
      </b-table>
    </b-card>
  </b-col>
</template>

<script>
import {
  BCol, BCard, BSpinner, BTable, BBadge,
} from 'bootstrap-vue'
import { formatarMoeda } from '../services/dashboardService'

export default {
  name: 'CampanhasTabela',
  components: {
    BCol,
    BCard,
    BSpinner,
    BTable,
    BBadge,
  },
  props: {
    ultimasCampanhas: {
      type: Array,
      required: true,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      camposTabela: [
        { key: 'name', label: 'Nome da Campanha', sortable: true },
        { key: 'audiencia', label: 'Audiência', sortable: false },
        { key: 'conversao', label: 'Conversão', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
      ],
    }
  },
  methods: {
    formatarMoeda(valor) {
      return formatarMoeda(valor)
    },

    getStatusVariantCampanha(status) {
      const variants = {
        completed: 'success',
        running: 'warning',
        paused: 'secondary',
        cancelled: 'danger',
        scheduled: 'info',
        failed: 'danger',
      }
      return variants[status] || 'secondary'
    },

    getStatusLabelCampanha(status) {
      const labels = {
        completed: 'Concluída',
        running: 'Em andamento',
        paused: 'Pausada',
        cancelled: 'Cancelada',
        scheduled: 'Agendada',
        failed: 'Falhou',
      }
      return labels[status] || status
    },
  },
}
</script>

<style scoped>
/* Estilos específicos se necessário */
</style>
